$( ( $ ) => {
  $( '.bs-pro-button--meet-our-team' ).on( 'click', ( e ) => {
    e.preventDefault();
    const goToSection = 'meet-our-team',
      currHref = $( e.target ).attr( 'href' );
    window.location = `${currHref}?section=${goToSection}`;
  } );
  const srchParam = new URLSearchParams( document.location.search ),
    hasSectionParam = srchParam.get( 'section' );
  if ( hasSectionParam ) {
    const meetOurTeamEl = $( `#${hasSectionParam}` );
    if ( meetOurTeamEl.length !== 0 ) {
      const hH = $( 'header' ).height(),
        elTop = meetOurTeamEl.offset().top;
      $( 'html, body' ).animate(
        {
          scrollTop: elTop - ( hH + 10 ),
        },
        500
      );
    }
  }
} );